function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "next_icn");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "[2nd-iteration]Grafill__Judging_phase_1_artwork_presentation_unrevealead_sidebar_ver2",
  transform: "translate(-1219.000000, -25.000000)",
  stroke: "#59CB9B",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "top_nav"
}, /*#__PURE__*/React.createElement("g", {
  id: "navigation",
  transform: "translate(1065.000000, 26.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "navigation_next",
  transform: "translate(101.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "next_icn",
  transform: "translate(61.000000, 9.500000) rotate(-90.000000) translate(-61.000000, -9.500000) translate(52.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: 1,
  x2: 8.21110255,
  y2: 11.8166538,
  id: "Line-3",
  strokeLinejoin: "bevel",
  transform: "translate(4.605551, 6.408327) rotate(-11.309932) translate(-4.605551, -6.408327) "
}), /*#__PURE__*/React.createElement("line", {
  x1: 9,
  y1: 1,
  x2: 16.2264988,
  y2: 11.8397482,
  id: "Line-3",
  strokeLinejoin: "round",
  transform: "translate(12.613249, 6.419874) scale(-1, 1) rotate(-11.309932) translate(-12.613249, -6.419874) "
})))))));

var SvgNextIcn = function SvgNextIcn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "21px",
    viewBox: "0 0 16 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNextIcn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/next_icn.7ca6c2ac.svg";
export { ForwardRef as ReactComponent };